<template>
	<div class="customerlist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-col :span="17">
							<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
						</el-col>
						<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
						<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
						<el-col :span="2" class="rightcol">
							<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 500 : 350" trigger="click">
								<table class="htmltable">
									<tr>
										<td>新增人</td>
										<td>
											<el-autocomplete
												ref="u_account"
												:trigger-on-focus="false"
												v-model="searchlist.u_account"
												:fetch-suggestions="searchuser"
												value-key="u_account"
												size="mini"
												style="width:98%"
											>
												<template slot-scope="{ item }">
													<div>{{ item.u_account }} ( {{ item.u_name }} )</div>
												</template>
											</el-autocomplete>
										</td>
									</tr>
									<tr>
										<td>客户编号</td>
										<td><el-input type="text" v-model="searchlist.cno" size="mini"></el-input></td>
									</tr>
									<tr>
										<td>客户名称</td>
										<td><el-input type="text" v-model="searchlist.cname" size="mini"></el-input></td>
									</tr>
									<tr>
										<td colspan="2" class="bottombtn">
											<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
											<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
										</td>
									</tr>
								</table>

								<el-link slot="reference" type="primary">更多筛选</el-link>
							</el-popover>
						</el-col>
					</el-row>
					<el-row style="height:10px;"></el-row>
					<el-row>
						<el-col :span="24">
							<tableui
								style="width:100%;"
								v-loading="loading"
								ref="packagetable"
								:tableData="customerlist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								:istop="istop"
							></tableui>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<pastorderwin ref="pastorderwin" @pastorderhandler="pastorderhandler"></pastorderwin>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
import pastorderwin from '@/components/order/pastorderwin.vue';
import exportwin from '@/components/order/exportwin.vue';
export default {
	components: {
		tableui,
		handlerbutton,
		pastorderwin,
		exportwin
	},
	data() {
		return {
			istop: false,
			searchlist: {
				cno: '',
				cname: '',
				u_account: ''
			},
			searchbox: '',
			activetab: '',
			activeName: '',
			activeTabIndex: 0, //激活的选项卡index
			type: '',
			pickerOptions: '',
			customerlist: [],
			gridheight: (window.innerHeight * 66) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '待处理事项', //当前操作的功能模块名称
			filterlist: [], //常用筛选条件
			selectedall: false,
			checkedrow: [],
			batch: '',
			divclass: 'customerlist',
			showpdf: '',
			showsuccesswin: false,
			isloadscroll: false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/crm/customerlist.scss');
			this.getTabs();
		});
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			var that = this;
			this.$apipost.get.GetTabs({ parentid: 192 }).then(res => {
				that.tabs = res.tabs;
				let tab = this.tabs[0];
				that.activeName = tab.type;
				that.activetab = tab.name;
				that.GetTabData();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				cno: '',
				cname: '',
				u_account: ''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
			}
			this.GetFilter(); //加载选项卡对应的筛选条件
			this.GetCustomerTodealCount(); //获取汇总数
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.refreshgrid(false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			this.istop = false;
			var isload = true;
			if (isrefresh) {
				this.customerlist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			// if(2>1)
			// 	return false;
			if (isload) {
				this.loading = true;
				var paraminfo = {
					search: this.GetSearchObj(),
					tab: this.tabs[this.activeTabIndex].type,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					l_mode: this.mode,
					iscount: 0,
					userid: localStorage.getItem('userid')
				};
				//console.log("开始加载列表"+ this.$tool.getcurrenttime());
				this.$apipost.get.GetCustomerTodeal({ paraminfo: paraminfo }).then(res => {
					//console.log("获取列表完成"+ this.$tool.getcurrenttime());
					that.loading = false;
					if (isload && !that.isloadscroll) {
						that.gridscroll();
					}
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.customerlist = that.customerlist.concat(res.data);
						} else {
							that.customerlist = res.data;
						}
					}
				});
				that.GetCustomerTodealCount(); //获取汇总数
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (search.fixfilter != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fixfilter) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				//console.log(JSON.stringify(res));
				that.refreshgrid(true);
			});
		},
		//获取物流管理汇总表
		GetCustomerTodealCount() {
			var that = this;
			this.$apipost.get.GetCustomerTodealCount({ search: this.GetSearchObj() }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						var countlist = res.countlist[0];
						for (var e in countlist) {
							if (e == that.tabs[i].type) {
								that.tabs[i].count = countlist[e];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			//console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			var that = this;
			if (e.event == 'exportorder') {
				this.InportOrder(e);
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			this.checkedrow = [];
			if(e.event=='handle'){
				Utils.$emit('go', {
					l_url: '/crm/customer_detail',
					l_name: '客户信息',
					l_id: e.l_id,
					urlparam: {id:this.customerlist[e.index].id,u_userid:this.customerlist[e.index].u_userid,updatetime:this.customerlist[e.index].updatetime,handle:'1'}
				});
			}
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fixfilter = value;
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				p_pkval: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e.p_pkval + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search.p_pkval = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选订单', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		pastorderhandler(e) {
			if (e.fun == '自定义导出') {
				var batch = e.checkedbatch;
				if (this.$refs.exportwin != undefined) {
					this.$refs.exportwin.init({
						batch: batch,
						pageparam: this._data,
						handtype: 1
					});
				}
			}
		},
		//导出
		ExportOrder() {
			var that = this;
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				if (that.$refs.exportwin != undefined) {
					that.$refs.exportwin.init({
						searchinfo: searchinfo,
						pageparam: that._data,
						handtype: 1
					});
				}
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '自定义导出'
					});
				}
			}
		},
		searchuser(val, cb) {
			var that = this;
			var search = new Object();
			if (this.u_account != '') {
				search.searchbox = this.searchlist.u_account;
			}
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '用户列表',
						tab: '',
						search: JSON.stringify(search),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}
			}, 300);
		}
	}
};
</script>
